<template>
<div class="state"
	:title="stateText"
	:class="[
		'user-'+user.props.id,
		{'idle': user.props.idle},
		{'online': user.props.online},
		{'offline': !user.props.online},
		{'busy': mapToStatusType(user.props.statusType) === 'Busy'}
	]">
	<span class="state-text">{{ stateText }}</span>
</div>
</template>

<script>
import { computed } from 'vue'
import { mapToStatusType } from '../js/user-functions.js'

const
	getStateText = ( props ) => {
		return ( props.statusType && mapToStatusType( props.statusType ) ) ||
			( props.idle ? 'Idle'
				: props.online ? 'Online'
					: 'Offline' )
	}

export default {
	props: {
		user: {
			type: [Object],
			required: true
		}
	},
	setup( props ){
		const stateText = computed(
			() => getStateText( props.user.props )
		)

		return {
			stateText,
			mapToStatusType
		}
	}
}
</script>